__turbopack_context__.v({
  "chart-section": "R2vc6G_chart-section",
  "chart-section__button-skeleton": "R2vc6G_chart-section__button-skeleton",
  "chart-section__chart-skeleton": "R2vc6G_chart-section__chart-skeleton",
  "chart-section__chart-slot": "R2vc6G_chart-section__chart-slot",
  "chart-section__chart-slot--hide": "R2vc6G_chart-section__chart-slot--hide",
  "chart-section__heading": "R2vc6G_chart-section__heading",
  "chart-section__headline--visually-hidden": "R2vc6G_chart-section__headline--visually-hidden",
  "chart-section__headline-skeleton": "R2vc6G_chart-section__headline-skeleton",
  "chart-section__info-container": "R2vc6G_chart-section__info-container",
  "chart-section__info-text": "R2vc6G_chart-section__info-text",
  "chart-section__info-text-additional": "R2vc6G_chart-section__info-text-additional",
  "chart-section__info-text-additional-skeleton": "R2vc6G_chart-section__info-text-additional-skeleton",
  "chart-section__info-text-skeleton": "R2vc6G_chart-section__info-text-skeleton",
  "chart-section__info-text-wrapper": "R2vc6G_chart-section__info-text-wrapper",
  "chart-section__sub-heading": "R2vc6G_chart-section__sub-heading",
  "chart-section__sub-heading--no-tabs": "R2vc6G_chart-section__sub-heading--no-tabs",
  "chart-section__sub-heading-skeleton": "R2vc6G_chart-section__sub-heading-skeleton",
  "chart-section__sub-heading-skeleton-container": "R2vc6G_chart-section__sub-heading-skeleton-container",
  "chart-section__tab": "R2vc6G_chart-section__tab",
  "chart-section__tab--focus-visible": "R2vc6G_chart-section__tab--focus-visible",
  "chart-section__tab--is-selected": "R2vc6G_chart-section__tab--is-selected",
  "chart-section__tabs-container": "R2vc6G_chart-section__tabs-container",
  "chart-section__tabs-container--hide": "R2vc6G_chart-section__tabs-container--hide",
  "chart-section__tabs-container-skeleton": "R2vc6G_chart-section__tabs-container-skeleton",
});
